/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const WorkAreaType = {
    Yard: 'Yard',
    Crane: 'Crane',
    Train: 'Train',
} as const;

export type WorkAreaType = typeof WorkAreaType[keyof typeof WorkAreaType];



